/* eslint-disable max-lines-per-function */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { Loader, Dimmer } from 'semantic-ui-react';
import ModalWrapper from '../../tw-partials/modal-wrapper';
import { Button } from '../../tw-partials/button';

const ErrorModalContentWrapper = styled.div`
  ${tw`min-h-80`};
`;

const ErrorModalHeader = styled.h2`
  ${tw`text-3xl text-center border-b border-gray-300 pb-7`};
  border-bottom-style: solid;

  p {
    ${tw`py-0 mt-2 text-base font-medium text-gray-600`};
  }
`;

const ErrorModalBody = styled.div`
  ${tw`my-8 font-medium`};
`;

const ErrorModalButtons = styled.div`
  ${tw`flex items-center justify-end`};

  button + button {
    ${tw`ml-6`};
  }
`;

const LoadingFeedback = styled.section`
  ${tw`w-full h-full`};
`;

const Input = styled.textarea`
  ${tw`
    py-2.5 px-3.5 w-full bg-transparent text-base border border-solid rounded-md border-grey-lighter 
    text-grey-dark font-normal mt-2
  `};
`;

const ErrorModal = ({ closeModal, submitReport, sendingError }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef(null);

  const submitErrorMessage = () => {
    if (errorMessage.trim()) {
      submitReport(errorMessage.trim());
    } else {
      inputRef.current.focus();
    }
  };

  return (
    <ModalWrapper closeModal={closeModal} background="#ffffff" padding="3rem" maxWidth={500}>
      <ErrorModalContentWrapper>
        <ErrorModalHeader>
          It looks like we are having issues
          <p>Please provide us with more information about the error that occurred. Our team will get notified.</p>
        </ErrorModalHeader>
        {sendingError ? (
          <LoadingFeedback>
            <Dimmer active>
              <Loader>Submitting...</Loader>
            </Dimmer>
          </LoadingFeedback>
        ) : (
          <>
            <ErrorModalBody>
              <label htmlFor="error-input">What Happened?</label>
              <Input
                ref={inputRef}
                value={errorMessage}
                placeholder="Enter steps that led to this error"
                onChange={(e) => setErrorMessage(e.target.value)}
                onBlur={(e) => setErrorMessage(e.target.value)}
                id="error-input"
                required
              />
            </ErrorModalBody>
            <ErrorModalButtons>
              <Button text="Cancel" type="primary icon" icon color="grey" iconLink="remove" onClick={closeModal} />
              <Button
                text="Submit Report"
                type="primary icon"
                icon
                color="grey"
                iconLink="check"
                onClick={submitErrorMessage}
              />
            </ErrorModalButtons>
          </>
        )}
      </ErrorModalContentWrapper>
    </ModalWrapper>
  );
};

ErrorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  submitReport: PropTypes.func.isRequired,
  sendingError: PropTypes.bool.isRequired,
};

export default ErrorModal;
